import { Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { headerCellStyle, orderSummaryDetailCellStyles, orderSummaryTableStyle, tableInRowStyle } from "./OrderSummaryTableStyles";

function OrderSummaryTableHeaderRow() {
 
  return (    
    <TableRow>
      <TableCell sx={{...headerCellStyle, ...orderSummaryTableStyle.productName}}>品名</TableCell>
      <TableCell sx={{...headerCellStyle, ...orderSummaryTableStyle.originName}}>産地</TableCell>
      <TableCell sx={{...headerCellStyle, ...orderSummaryTableStyle.size}}>規格</TableCell>
      <TableCell sx={{...headerCellStyle, ...orderSummaryTableStyle.details}}>
      <Grid container columnSpacing={2}>
        <Grid item xs sx={orderSummaryDetailCellStyles.customerShopName}>取引先店舗</Grid>
        <Grid item xs sx={orderSummaryDetailCellStyles.unitQuantity}>入数</Grid>
        <Grid item xs sx={orderSummaryDetailCellStyles.orderQuantity}>数量</Grid>
        <Grid item xs sx={orderSummaryDetailCellStyles.orderingUnitName}>発注単位</Grid>
      </Grid>
      </TableCell>
      <TableCell sx={{...headerCellStyle, ...orderSummaryTableStyle.total}}>
        <Table sx={{py: 0}}>
          <TableBody sx={tableInRowStyle}>
          <TableRow>
            <TableCell  sx={{...headerCellStyle}}>集計</TableCell>
          </TableRow>
          <TableRow >
            <TableCell sx={{...headerCellStyle}}>
              <Grid container spacing={1}>
                <Grid item xs minWidth={"100px"}>ケース</Grid>
                <Grid item xs minWidth={"100px"}>バラ</Grid>
                <Grid item xs minWidth={"100px"}>kg</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          </TableBody>
        </Table>
      </TableCell>
     
    </TableRow>
  )
}

export default OrderSummaryTableHeaderRow;